 

function BuyDetail(probs) {

    const side = probs.side;

    return ( 
       <>
          <div className="col-md-6 d-flex flex-column justify-content-center text-light modern-box">
              <h2 className="mb-4">{ side.title }</h2>
              <p className="lead">{side.subheading}</p>
              <p className="mb-4">{side.detail}</p>
              <button className="btn btn-modern">Buy Now!</button>
          </div>
       </> 
 ); 

}

export default BuyDetail;